import React from "react";
var __jsx = React.createElement;
import Unbxd from "./Unbxd";
import { SearchContextProvider } from "@/pages/search/searchHooks/SearchContext";
var SearchRenderer = function SearchRenderer() {
  return /*#__PURE__*/React.createElement(SearchContextProvider, null, /*#__PURE__*/React.createElement(Unbxd, null));
};
export default SearchRenderer;